import { Box } from '@hivebrite/design-system/Box';
import { CardWithTitle } from '@hivebrite/design-system/Card';
import { Divider } from '@hivebrite/design-system/Divider';

import type { TicketItem } from 'hb-react/shared/apps/Events/pages/Booking/hooks/useBooking';

import { Ticket } from './components/Ticket';

interface TicketTableProps {
  tickets: TicketItem[];
  readOnly?: boolean;
  isLoading?: boolean;
  maxTicketsPerUser?: number;
}

export const TicketTable = ({
  tickets = [],
  readOnly = false,
  isLoading = false,
  maxTicketsPerUser,
}: TicketTableProps) => {
  if (!tickets.length) {
    return null;
  }

  return (
    <CardWithTitle
      data-testid="ticket-table"
      title={s__('NetworkEvents|Available Tickets')}
    >
      {maxTicketsPerUser ? (
        <Box font="body-dove-italic" pb={4}>
          {I18n.t(
            'web.networks.events.attendees.reach_max_tickets_per_user.title',
            {
              number: maxTicketsPerUser,
            },
          )}
        </Box>
      ) : null}
      {tickets.map((ticket, index) => (
        <Box
          flexDirection="column"
          key={ticket.id}
          dataTestId="ticket-row-container"
        >
          <Ticket
            ticket={ticket}
            index={index}
            readOnly={readOnly || !ticket.buyable}
            isLoading={isLoading}
          />
          {index + 1 < tickets.length && <Divider />}
        </Box>
      ))}
    </CardWithTitle>
  );
};
